import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Suspense, lazy } from 'react';
// import CareerLaunchpad from "../Components/Dashboard/CareerLaunchpad";
import SkeletonL from "../Components/Skeleton/Withlogin";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const CareerLaunchpad = lazy(() => import('../Components/Dashboard/CareerLaunchpad'));
const AuthCareerlaunchpad = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Suspense fallback={<SkeletonL/>}>
  <CareerLaunchpad/>
</Suspense> : <SessionTimeoutRedirect />
}
export default AuthCareerlaunchpad;


